import { render } from "./SmLogo.vue?vue&type=template&id=62d43ea6&scoped=true"
const script = {}

import "./SmLogo.vue?vue&type=style&index=0&id=62d43ea6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d43ea6"]])

export default __exports__